"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Physics3DModule = void 0;
var core_1 = require("../core");
var physics3DSystem_1 = require("./physics3DSystem");
var Physics3DModule = /** @class */ (function (_super) {
    __extends(Physics3DModule, _super);
    function Physics3DModule(options) {
        var _this = _super.call(this) || this;
        _this.declareSystems([new physics3DSystem_1.Physics3DSystem(options)]);
        return _this;
    }
    return Physics3DModule;
}(core_1.RealmModule));
exports.Physics3DModule = Physics3DModule;
